import React, { useState } from 'react';
// Removed unused Firestore imports, they should be handled in the parent (WarrantyList)
import ItemDrawer from './ItemDrawer';
// Removed SearchComponent import, seems unused within CardView itself

// MUI Imports
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import QrCodeIcon from '@mui/icons-material/QrCode';
import ComplaintIcon from '@mui/icons-material/ReportProblem';
import Grid from '@mui/material/Grid';
import Checkbox from '@mui/material/Checkbox';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
// Removed unused 'collection' import

// NOTE: Renamed 'items' prop to 'initialItems' to avoid conflict with internal state if needed later.
// Removed internal 'items' state and useEffect for fetching, as data should be passed down from WarrantyList.
// Removed itemsToShow and loadMoreItems, pagination should be handled in WarrantyList.
// Removed searchQuery state and handlers, they belong in WarrantyList or SearchComponent.
// Removed handleSelectAll, it's managed in WarrantyList.
function CardView({
  items: passedItems = [], // Renamed prop and added default value
  onEdit,
  onDelete,
  onGenerateQR,
  onRaiseComplaint,
  selectedRows = [], // Added default value
  setSelectedRows // This should be the handler function from parent
}) {
  const [openDrawer, setOpenDrawer] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  // Removed user and userId state, not needed if data fetching is in parent

  // Remove useEffect for auth state change - handled in parent
  // Remove useEffect for fetching items - handled in parent

  const handleOpenDrawerInternal = (item) => {
    setSelectedItem(item);
    setOpenDrawer(true);
  };

  const handleCloseDrawer = () => {
    setOpenDrawer(false);
    setSelectedItem(null);
  };

  // Use the passed handler function directly for selecting/deselecting
  const handleSelect = (itemId) => {
    setSelectedRows(itemId); // Call the function passed from WarrantyList
  };


  // Filtering is now done in WarrantyList, so CardView receives already filtered items
  // const filteredItems = items.filter(item => ... ); // REMOVED


  return (
    <div>
      {/* Select All Checkbox is removed - handled in WarrantyList */}
      {/* <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>...</Box> */}

      <Grid container spacing={2}>
        {/* Use passedItems directly, no slicing */}
        {passedItems.map((item) => (
          <Grid item xs={12} sm={6} md={4} lg={2.4} key={item.id}>
            <Card sx={{
              // maxWidth: 345, // Removed to allow grid sizing
              height: '100%', // Make card fill grid item height
              display: 'flex', // Use flexbox for layout
              flexDirection: 'column', // Stack image, content, actions vertically
              position: 'relative',
              boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.2)',
              transform: 'translateY(0)',
              transition: 'transform 0.3s ease, box-shadow 0.3s ease',
              '&:hover': {
                transform: 'translateY(-5px)',
                boxShadow: '0px 8px 20px rgba(0, 0, 0, 0.3)',
              },
              borderRadius: '10px',
            }}>
              <Box sx={{ // Changed div to Box for consistency
                width: '100%',
                height: '150px', // Fixed height for image area
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                overflow: 'hidden',
                borderTopLeftRadius: '10px', // Keep radius
                borderTopRightRadius: '10px', // Keep radius
                backgroundColor: '#f0f0f0', // Background for missing images
                textAlign: 'center',
              }}>
                {item.imageUrl ? (
                  <Box // Use Box for image container
                    component="img"
                    src={item.imageUrl}
                    alt={item.productName || item.itemMake || 'Item image'} // Better alt text
                    sx={{
                      maxWidth: '100%', // Ensure image fits width
                      maxHeight: '100%', // Ensure image fits height
                      width: 'auto', // Adjust width automatically
                      height: 'auto', // Adjust height automatically
                      objectFit: 'contain', // Use contain to see full image
                      display: 'block',
                    }}
                    onError={(e) => { e.target.style.display = 'none'; }} // Hide broken images
                  />
                ) : (
                  <Typography variant="body2" color="text.secondary">
                    Image not available
                  </Typography>
                )}
              </Box>

              {/* Ensure CardContent grows to push actions down */}
              <CardContent sx={{ flexGrow: 1, pb: 1 }}> {/* Reduced bottom padding */}
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}> {/* Added margin bottom */}
                  <Typography variant="h6" component="div" sx={{ flexGrow: 1, fontSize: '1rem', fontWeight: 'bold' }}> {/* Adjusted Typography */}
                    {item.productName || item.itemMake || 'Unnamed Item'} {/* Provide fallback name */}
                  </Typography>
                  <Checkbox
                    checked={selectedRows.includes(item.id)}
                    onChange={() => handleSelect(item.id)} // Use the passed handler
                    inputProps={{ 'aria-label': `Select item ${item.id}` }}
                    size="small" // Make checkbox smaller
                    sx={{ p: 0.5 }} // Adjust padding
                  />
                </Box>

                <Typography variant="body2" color="text.primary" noWrap> {/* Added noWrap */}
                  Make: {item.itemMake || 'N/A'}
                </Typography>

                <Typography variant="body2" color="text.primary" noWrap> {/* Added noWrap */}
                  Model: {item.model || 'N/A'}
                </Typography>

                <Typography variant="caption" color="text.secondary" display="block"> {/* Smaller text */}
                  Purchased: {item.purchaseDate || 'N/A'}
                </Typography>

                <Typography variant="caption" color="text.secondary" display="block"> {/* Smaller text */}
                  Expires: {item.warrantyExpiryDate || 'N/A'}
                </Typography>
              </CardContent>

              <CardActions sx={{ justifyContent: 'space-around', pt: 0 }}> {/* Space out icons, remove top padding */}
                <Tooltip title="More Details">
                  {/* Use internal handler to open drawer */}
                  <IconButton onClick={() => handleOpenDrawerInternal(item)} aria-label="info" size="small">
                    <UnfoldMoreIcon fontSize='small' />
                  </IconButton>
                </Tooltip>

                <Tooltip title="Edit Details">
                  <IconButton onClick={() => onEdit(item.id)} aria-label="edit" size="small" color="primary">
                    <EditIcon fontSize='small' />
                  </IconButton>
                </Tooltip>

                <Tooltip title="QR Code">
                  <IconButton onClick={() => onGenerateQR(item)} aria-label="generate QR code" size="small">
                    <QrCodeIcon fontSize='small' />
                  </IconButton>
                </Tooltip>

                <Tooltip title="Raise Complaint">
                  <IconButton onClick={() => onRaiseComplaint(item.id)} aria-label={`Raise Complaint ${item.id}`} size="small" color="warning">
                    <ComplaintIcon fontSize='small' />
                  </IconButton>
                </Tooltip>

                <Tooltip title="Delete">
                  <IconButton onClick={() => onDelete(item.id)} aria-label="delete" size="small" color="error">
                    <DeleteIcon fontSize='small' />
                  </IconButton>
                </Tooltip>
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* Load More Button is removed - handled in WarrantyList */}
      {/* {itemsToShow < items.length && (...)} */}

      {/* ItemDrawer is managed internally in this version */}
      <ItemDrawer
        open={openDrawer}
        onClose={handleCloseDrawer}
        item={selectedItem}
        onEdit={onEdit} // Pass these down if needed by ItemDrawer
        onGenerateQRCode={onGenerateQR} // Pass these down if needed by ItemDrawer
        onRaiseComplaint={onRaiseComplaint} // Pass these down if needed by ItemDrawer
      />
    </div>
  );
}

export default CardView;